<template>
  <v-dialog v-model="show"
            width="450"
  >
    <v-sheet class="mx-auto">
      <v-toolbar height="80">
        <v-btn icon width="80" height="80"
               disabled
        />

        <v-spacer />

        <v-toolbar-title>공유 하기</v-toolbar-title>

        <v-spacer />

        <v-btn icon
               width="80"
               height="80"
               @click="show = false"
        >
          <v-icon size="50">
            $close
          </v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider />

      <v-card-text class="pa-4">
        <v-row class="">
          <v-col cols="12" class="d-flex justify-center">
            <div class="mr-8">
              <img src="/images/common/ico-talk.png"
                   alt="카카오톡에 공유"
                   role="button"
                   @click="shareKakao"
              >
            </div>

            <div class="mr-8">
              <img src="/images/common/ico-naver.png"
                   alt="네이버에 공유"
                   role="button"
                   @click="shareNaver"
              >
            </div>

            <div>
              <img src="/images/common/ico-line.png"
                   alt="라인에 공유"
                   role="button"
                   @click="shareLine"
              >
            </div>
          </v-col>
        </v-row>

        <v-row class="justify-center">
          <v-col cols="12">
            <v-text-field class="share__input"
                          height="60"
                          outlined
                          readonly
                          hide-details
                          :value="computedUrl"
            />
            <v-btn v-clipboard:copy="computedUrl"
                   v-clipboard:success="successCopied"
                   color="secondary"
                   class="share__input mt-1"
                   height="60"
                   block
            >
              URL 복사
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-sheet>
  </v-dialog>
</template>

<script>

import { sync } from 'vuex-pathify';

export default {
  name: 'ShareDialog',
  components: {},
  props: {
    value: { type: Boolean, default: false },
  },
  data: () => ({}),
  computed: {
    shareTitle: sync('share/shareTitle'),
    shareText: sync('share/shareText'),
    shareUrl: sync('share/shareUrl'),
    show: {
      get () {
        return this.value;
      },
      set (value) {
        if (!value) {
          this.shareTitle = null;
          this.shareText = null;
          this.shareUrl = null;
        }
        this.$emit('input', value);
      },
    },
    computedTitle () {
      return this.shareTitle;
    },
    computedText () {
      return this.shareText;
    },
    computedUrl () {
      return `https://o-lens.com${this.shareUrl}`;
      // return `${process.env.VUE_APP_BASE_URL}${this.shareUrl}`;
    },
  },
  mounted () {
  },
  methods: {
    successCopied () {
      this.$dialog.message.success('URL 복사가 완료되었습니다.');
    },
    shareKakao () {
      /* global Kakao */
      if (!Kakao.isInitialized()) {
        Kakao.init(process.env.VUE_APP_KAKAO_KEY);
      }

      Kakao.Share.sendDefault({
        objectType: 'feed',
        content: {
          title: this.computedTitle,
          description: this.computedText,
          imageUrl: 'https://o-lens.com/images/share_image.png',
          imageWidth: 800,
          imageHeight: 400,
          link: {
            mobileWebUrl: this.computedUrl,
            webUrl: this.computedUrl,
          },
        },
      });
    },
    shareNaver () {
      window.open(`https://share.naver.com/web/shareView?url=${encodeURI(this.computedUrl)}&title=${encodeURI(this.computedTitle)}`,
        'Share on Naver',
        'scrollbars=no, width=500, height=500',
      );
    },
    shareFacebook () {
      window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURI(this.computedUrl)}`,
        'Share on Facebook',
        'scrollbars=no, width=500, height=500',
      );
    },
    shareLine () {
      window.open(`https://social-plugins.line.me/lineit/share?url=${encodeURI(this.computedUrl)}&text=${encodeURI(this.computedText)}`);
    },
  },
};
</script>